module.exports = __webpack_public_path__ + "img/02.08534a8a.jpg";